// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_i0-7";
export var emphasizeQuantity = "_i0-3";
export var flatBottomCorners = "_i0-5";
export var productImage = "_i0-0";
export var quantityContainer = "_i0-2";
export var quantityHeader = "_i0-6";
export var tooltip = "_i0-1";
export var wrapAndEllipsesOverflow = "_i0-4";